import { useNavigate, useParams } from "react-router-dom";
import Order from "./order";

/** Страница просмотра заказа по публичной ссылке /doc/:code (без авторизации) */
const OrderDoc = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  if (!code) return null;
  return (
    <Order
      code={code}
      standalone
      onClose={() => navigate("/")}
    />
  );
};

export default OrderDoc;
